import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CurrentDataSlice {
  loggedInUserData: any;
  forgotPwdEmail: string;
  projectData: any;
  planData: any;
  taskData: any;
  dependencyData: any;
  checksData: any
}

const initialState: CurrentDataSlice = {
  loggedInUserData: null,
  forgotPwdEmail: "",
  projectData: null,
  planData: null,
  taskData: null,
  dependencyData: null,
  checksData: null
};

const currentDataSlice = createSlice({
  name: "currentData",
  initialState,
  reducers: {
    setLoggedInUserData(state, action: PayloadAction<any>) {
      state.loggedInUserData = action.payload;
    },
    setForgotPwdEmail(state, action: PayloadAction<string>) {
      state.forgotPwdEmail = action.payload;
    },
    setProjectData(state, action: PayloadAction<any>) {
      state.projectData = action.payload;
    },
    setPlanData(state, action: PayloadAction<any>) {
      state.planData = action.payload;
    },
    setTaskData(state, action: PayloadAction<any>) {
      state.taskData = action.payload;
    },
    setDependencyData(state, action: PayloadAction<any>) {
      state.dependencyData = action.payload;
    },
    setChecksData(state, action: PayloadAction<any>) {
      state.checksData = action.payload;
    },
    reset(state) {
      state.loggedInUserData = null;
    },
  },
});

export const { setLoggedInUserData, reset, setForgotPwdEmail, setProjectData, setTaskData, setDependencyData, setChecksData, setPlanData } =
  currentDataSlice.actions;

export default currentDataSlice.reducer;
